import './ModalItem.scss';

import React, { useMemo } from 'react';

import Picture from '@/common/components/atoms/Picture/Picture';
import Video from '@/common/components/atoms/Video/Video';
import { MEDIA_TYPES } from '@/common/constants';

import {
  ModalItemDefaultProps,
  ModalItemPropTypes,
} from './ModalItem.proptypes';

const ModalItem = ({ alt, className, path, type }) => {
  const classNames = useMemo(
    // TODO: Clean classNames
    () => ['slider-media__item', className].filter((val) => val).join(' '),
    [className],
  );

  return (
    // TODO: Clean classNames
    <div className={classNames} data-qa-id="modal-item">
      <div className={`slider-media__${type}-wrapper`}>
        {type === MEDIA_TYPES.VIDEO ? (
          <Video src={path} title={alt} className="slider-media__video" />
        ) : (
          <Picture src={path} alt={alt} className="slider-media__image" />
        )}
      </div>
    </div>
  );
};

ModalItem.defaultProps = {
  ...ModalItemDefaultProps,
};

ModalItem.propTypes = {
  ...ModalItemPropTypes,
};

export default ModalItem;
